import config from '@cardash/config';

const GENERAL_ERROR_MESSAGE = 'Something went wrong, please try again';
const STATIC_ASSETS_URL =
  process.env.NEXT_PUBLIC_STATIC_ASSETS_URL ?? 'https://sfac-static-assets.s3.us-west-1.amazonaws.com';

const SFAC_APP_URL = config.sfacAppUrl || 'https://app.stressfree.com';

export { GENERAL_ERROR_MESSAGE, STATIC_ASSETS_URL, SFAC_APP_URL };
